import api from './BaseApi';
import { setAuthTokenCookie, removeAuthTokenCookie, getAuthTokenCookie } from '../utils/cookies';

export const login = async (email, password) => {
    try {
        const response = await api.post('/auth/login', { email, password });
        const token = response.data.token;
        const user = response.data.data;
        if (token) {
            setAuthTokenCookie(token);
            if (user) {
                localStorage.setItem('adminUser', JSON.stringify(user));
            }
        }
        return response;
    } catch (error) {
        console.error('Login error:', error);
        throw error;
    }
};

export const logout = async () => {
    try {
        const response = await api.post('/logout');
        removeAuthTokenCookie();
        localStorage.removeItem('adminUser');
        return response;
    } catch (error) {
        console.error('Logout error:', error);
        throw error;
    }
};

export const deleteAccount = async (email, password) => {
    try {
        const response = await api.post('/auth/delete-account', { email, password });
        return response;
    } catch (error) {
        console.error('Delete account error:', error);
        throw error;
    }
};

export const getToken = () => {
    return getAuthTokenCookie();
};

export const isAuthenticated = () => {
    return !!getAuthTokenCookie();
};

export const forgotPassword = async (email) => {
    try {
        const response = await api.post('/auth/forgot-password', { email });
        console.log('Forgot password response:', response.data);
        return response;
    } catch (error) {
        console.error('Forgot password error:', error);
        throw error;
    }
};

export const verifyOtp = async (email, otp) => {
    try {
        const response = await api.post('/auth/verify-forgot-password-otp', { email, otp });
        console.log('Verify OTP response:', response.data);
        return response;
    } catch (error) {
        console.error('Verify OTP error:', error);
        throw error;
    }
};

export const resendOtp = async (email) => {
    try {
        const response = await api.post('/auth/resend-forgot-password-otp', { email });
        console.log('Resend OTP response:', response.data);
        return response;
    } catch (error) {
        console.error('Resend OTP error:', error);
        throw error;
    }
};

export const resetPassword = async (email, new_password, confirm_password) => {
    try {
        const response = await api.post('/auth/reset-password', { email, new_password, confirm_password });
        console.log('Reset Password response:', response.data);
        return response;
    } catch (error) {
        console.error('Reset Password error:', error);
        throw error;
    }
};
